var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { GET_USERS_REQUEST, GET_USERS_SUCCESS, GET_USERS_FAILURE, SELECT_USER, QUERY_USERS, SELECT_ALL_USERS, INVITE_USER_REQUEST, INVITE_USER_FAILURE, INVITE_USER_SUCCESS, } from './constants';
import services from '../../services';
var GroupService = services.GroupService, UserService = services.UserService;
export var getUsers = function (appId, organizationId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var resp, allUsers, meta, users, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 6]);
                dispatch({ type: GET_USERS_REQUEST });
                resp = void 0;
                if (!appId) return [3 /*break*/, 2];
                return [4 /*yield*/, GroupService.getGroupMembers("app:".concat(appId, ":users"))];
            case 1:
                resp = _a.sent();
                return [3 /*break*/, 4];
            case 2: return [4 /*yield*/, UserService.listUsers(organizationId)];
            case 3:
                resp = _a.sent();
                _a.label = 4;
            case 4:
                allUsers = resp.objects, meta = resp.meta;
                users = allUsers.map(function (u) { return (__assign(__assign({}, u), { selected: false })); });
                dispatch({ type: GET_USERS_SUCCESS, users: users, usersAppId: appId, meta: meta });
                return [3 /*break*/, 6];
            case 5:
                err_1 = _a.sent();
                dispatch({ type: GET_USERS_FAILURE });
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}); }; };
export var queryUsers = function (searchQuery) { return function (dispatch) {
    dispatch({ type: QUERY_USERS, searchQuery: searchQuery });
}; };
export var selectUser = function (userId, selected) { return function (dispatch) {
    dispatch({ type: SELECT_USER, userId: userId, selected: selected });
}; };
export var selectAllUsers = function (selected) { return function (dispatch) {
    dispatch({ type: SELECT_ALL_USERS, selected: selected });
}; };
export var inviteMembers = function (userIds, appId, org) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: INVITE_USER_REQUEST });
                return [4 /*yield*/, UserService.inviteAgain(userIds, appId, org)];
            case 1:
                _a.sent();
                dispatch({ type: INVITE_USER_SUCCESS });
                return [2 /*return*/, true];
            case 2:
                err_2 = _a.sent();
                dispatch({ type: INVITE_USER_FAILURE });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, false];
        }
    });
}); }; };
